"use strict";
exports.__esModule = true;
exports.isVideo = exports.PreloadableGalleryComponent = void 0;
var PreloadableGalleryComponent_1 = require("./components/PreloadableGalleryComponent");
exports.PreloadableGalleryComponent = PreloadableGalleryComponent_1["default"];
var PreloadApi_1 = require("./PreloadApi");
exports.isVideo = PreloadApi_1.isVideo;
